import { cloneElement, type FC, isValidElement, type ReactNode } from "react";

interface CardHeaderProps {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}

const CardHeader: FC<CardHeaderProps> = ({ children, icon, className = "" }) => {
  const iconWithClasses =
    icon && isValidElement(icon)
      ? cloneElement(icon, {
          color: "action",
          ...icon.props,
          sx: { fontSize: "24px", ...icon.props.sx },
          className: `row-span-2 items-center ${icon.props.className || ""}`,
        })
      : icon;

  return (
    <header
      className={`grid ${icon ? "grid-cols-[auto_1fr]" : "grid-cols-1"} gap-x-3 items-center ${className}`}
    >
      {iconWithClasses}
      {children}
    </header>
  );
};

export default CardHeader;
